import { Injectable, inject, signal } from '@angular/core';
import { PrintRepository } from '../repositories/print.repository';

@Injectable()
export class PrintService {
  #printRepository = inject(PrintRepository);
  readonly loading = signal(false);

  async loadDocument(id: number, start: string, end: string): Promise<string | null> {
    try {
      this.loading.set(true);
      const request = await this.#printRepository.retrieve(id, start, end);
      this.loading.set(false);
      return request;
    } catch (error) {
      console.error('Error loading document:', error);
      this.loading.set(false);
      return null;
    }
  }

  async print(type: string, orderId: number) {
    const request = await this.#printRepository.retrieve2(type, orderId);
    return request;
  }
}
